import { Type } from "class-transformer";
import { Calendar } from "./Calendar";
import { ResourceType } from "./ResourceType";

export class Resource {
    //netgen start
    title: string;
    typeId: number = null;
    @Type(() => ResourceType)
    type: ResourceType;
    @Type(() => Calendar)
    calendar: Calendar;
    calendarId = 0;
    mail: string;
    color = 0;
    id = 0;
    //netgen end
}
